export default __webpack_public_path__ + "static/media/icon-like-poppy-active.41a87d05.webp";